module.exports = __webpack_public_path__ + "media/images/banner/4-67a1574b43448bcd3db3cfac769cafca.jpg";